import { useTranslate } from "react-admin";

import { FinancialChartsDataGrid } from "./FinancialChartsDataGrid";

export const CustomerArticlesDatagrid = ({ customerArticles }) => {
	const translate = useTranslate();

	const columns = [
		{
			key: "article_code",
			label: translate("resources.financial-statements.customer-articles-grid.fields.article_code"),
		},
		{
			key: "name",
			label: translate("resources.financial-statements.customer-articles-grid.fields.name"),
		},
		{
			key: "units",
			label: translate("resources.financial-statements.customer-articles-grid.fields.units"),
		},
		{
			key: "revenue",
			label: translate("resources.financial-statements.customer-articles-grid.fields.revenue"),
			render: (value) => (value ?? 0).toFixed(2),
		},
	];

	return (
		<FinancialChartsDataGrid
			rows={customerArticles}
			columns={columns}
			getRowKey={(row) => row.article_code}
		/>
	);
};
